import {Button, useNotify, useRecordContext} from "react-admin";
import {config} from "../config";
import {getJwtHeader} from "../auth/authProvider";
import Send from '@mui/icons-material/Send';
import {Box} from "@mui/material";
import {Dialog} from "@material-ui/core";
import * as React from "react";
import {useState} from "react";

export const NoticeSendButton = () => {
    const record = useRecordContext();
    const [warningOpen, setWarningOpen] = useState(false)
    const notify = useNotify();
    const handleClick = async () => {
        await sendNotice(record.id.toString()).then(async res => {
            setWarningOpen(false)
            if (!res.ok) {
                await res.text().then(text => {
                    notify(text, {type: 'error'});
                })
            } else {
                notify(`Sikeres kiküldés!`, {type: 'success'});
            }
        })
    }

    return <>
        <Button
            label={"Üzenet kiküldése"}
            endIcon={<Send/>}
            onClick={() => setWarningOpen(true)}
        />
        <Dialog open={warningOpen} onClose={() => setWarningOpen(false)}>
            <Box sx={{minWidth: '500px', padding: '20px', backgroundColor: '#17460a', color: 'white'}}>
                <Box sx={{fontWeight: 700, fontSize: 18, marginBottom: '10px'}}>Figyelmeztetés</Box>
                <Box>Az értesítés minden felhasználónak kiküldésre kerül. Biztosan ki akarod küldeni?</Box>
                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px'}}>
                    <Button
                        label={"Mégse"}
                        variant="contained"
                        onClick={() => setWarningOpen(false)}
                    />
                    <Button
                        label={"Üzenet kiküldése"}
                        variant="contained"
                        endIcon={<Send/>}
                        onClick={handleClick}
                    />
                </Box>
            </Box>
        </Dialog>
    </>
}

async function sendNotice(noticeId: String) {
    return fetch(`${config.apiUrl}/notice/_${noticeId}/send`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getJwtHeader()
        }
    });
}
